import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import en from './locales/en.json';
import fr from './locales/fr.json';
import de from './locales/de.json';
import es from './locales/es.json';
import it from './locales/it.json';
import bg from './locales/bg.json';
import ru from './locales/ru.json';
import uk from './locales/uk.json';
import be from './locales/be.json';
import zh from './locales/zh.json';
import fa from './locales/fa.json';

// Supported languages
const supportedLanguages = ['en', 'fr', 'de', 'es', 'it', 'bg', 'ru', 'uk', 'be', 'zh', 'fa'];

// Get saved language from localStorage or use default
const getSavedLanguage = () => {
  const savedLang = localStorage.getItem('i18nextLng');
  return savedLang && supportedLanguages.includes(savedLang) ? savedLang : 'en';
};

// Initialize i18next
i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      de: { translation: de },
      es: { translation: es },
      it: { translation: it },
      bg: { translation: bg },
      ru: { translation: ru },
      uk: { translation: uk },
      be: { translation: be },
      zh: { translation: zh },
      fa: { translation: fa },
    },
    lng: getSavedLanguage(),
    fallbackLng: 'en',
    supportedLngs: supportedLanguages,
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    react: {
      useSuspense: false, // Disable suspense for React 17 compatibility
    },
  });

// Save language changes to localStorage
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('i18nextLng', lng);
});

export default i18n;
